import { FieldType } from '@teable/core';

export const FIELD_TYPE_ORDER = [
  FieldType.SingleLineText,
  FieldType.LongText,
  FieldType.Number,
  FieldType.SingleSelect,
  FieldType.MultipleSelect,
  FieldType.User,
  FieldType.Date,
  FieldType.Rating,
  FieldType.Checkbox,
  FieldType.Attachment,
  FieldType.Formula,
  FieldType.Link,
  FieldType.Rollup,
  FieldType.CreatedTime,
  FieldType.LastModifiedTime,
  FieldType.CreatedBy,
  FieldType.LastModifiedBy,
  FieldType.AutoNumber,
];
